module.exports = "- Use the FloatingPeoplePicker to quickly search for a few people\n"